import styled from 'styled-components';
import TopDownPage from './components/pages/TopDownPage';
import { GlobalStyles, ThemeProvider } from './styles';
import SafeAreaHelloWorld from './TestRoot';

const AppContainer = styled.main`
  margin: 0;
  padding: 0;
  background-color: #F6F6F6;
`;

function App() {
  return (
    <ThemeProvider>
      <GlobalStyles />
      <AppContainer>
        <TopDownPage />
      </AppContainer>
        {/* <SafeAreaHelloWorld /> */}
    </ThemeProvider>
  );
}

export default App;
